import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import './App.css';
import AnalyticsTracker from './commonServices/AnalyticsTracker';
import { getUniqueId } from './commonServices/commonService';
import { getCookie, saveCookie, setTokenInHeader } from './commonServices/cookieService';
import BlogPage from './jsx/BlogPage/BlogPage';
import AttemptTest from './jsx/Books/AttemptTest';
import BookDetailsNew from './jsx/Books/BookDetailsNew';
import BookLessonPage from './jsx/Books/BookLessons/BookLessonPage';
import LessonResult from './jsx/Books/BookLessons/LessonResult';
import BookPracticeTestReport from './jsx/Books/BookPracticeTestReport';
import Books from './jsx/Books/Books';
import BookTestSeries from './jsx/Books/BookTestSeries';
import ReportDashboard from './jsx/Books/ReportDashboard';
import StartBookTest from './jsx/Books/StartBookTest';
import HistoryOptionalCourses from './jsx/CivilPage/CivilHistory/HistoryOptionalCourses';
import Civilabout from './jsx/CivilPage/CivilHome/Civilabout';
import CivilsCard from './jsx/CivilPage/CivilsCard/CivilsCard';
import CivilsTest from './jsx/CivilPage/CivilsCard/CivilsTest';
import CivilOpt from './jsx/CivilPage/CivilHistory/CivilOptClass';
import Contact from './jsx/Contact/Contact';
import CourseDescription from './jsx/CourseDescription/CourseDescription';
import CUET_Report from './jsx/CUET/Common/CUET_Report';
import Cuet from './jsx/CUET/Cuet';
import AttemptTestCUET from './jsx/CUET/OnlineTest/AttemptTestCUET';
import Instructions from './jsx/CUET/OnlineTest/Instructions';
import PaymentSuccessPage from './jsx/CUET/PaymentService/PaymentSuccessPage';
import CUET_Resources from './jsx/CUET/Resources/ResourcesHome';

import GeneralAptitudeTestHome from './jsx/CUET/GeneralAptitudeTest/GeneralAptitudeTestHome';
import LanguageSubjectsHome from './jsx/CUET/LanguageSubjects/LanguageSubjectsHome';
import DomainSpecificSubjectsHome from './jsx/CUET/DomainSpecificSubjects/DomainSpecificSubjectsHome';

import Current from './jsx/CurrentPage/Current';
import Dashborad from './jsx/Dashborad/Dashborad';
import DynamicaboutPage from './jsx/DynamicaboutPage/DynamicaboutPage';
import Dynamicblog from './jsx/Dynamicblog/Dynamicblog';
import DynamicToday from './jsx/Dynamicblog/DynamicToday';
import DynamicCourse from './jsx/DynamicCourse/DynamicCourse';
import DynamicNews from './jsx/DynamicNews/DynamicNews';
import DynamicTestseries from './jsx/DynamicTestseries/DynamicTestseries';
import Finalresult from './jsx/Finalresult/Finalresult';
import Footer from './jsx/Footer/Footer';
import Forgot from './jsx/Forgot/Forgot';
import Header from './jsx/Header/Header';
import Home from './jsx/Home/Home';
import Homequiz from './jsx/Homequiz/Homequiz';
import { QuizDetailsProvider } from './jsx/Homequiz/QuizContext';
import InterviewGuidance from './jsx/InterviewGuidance/InterviewGuidance';
import PaymentSuccessIGP from './jsx/InterviewGuidance/PaymentSuccess';
import Login from './jsx/Login/Login';
import PaymentSuccess from './jsx/PaymentSuccess/PaymentSuccesscourse';
import QuestionLayoutTestseries from './jsx/QuizComponent/QuestionLayout/QuestionLayoutTestseries';
import Reportcard from './jsx/Reportcard/Reportcard';
import Reportcard1 from './jsx/Reportcard/Reportcard1';
import DynamicTestSeriesHome from './jsx/ReusableComponent/NEET/DynamicTestSeriesHome';
import AttemptTestNEET from './jsx/ReusableComponent/NEET/Examination/AttemptTestNEET';
import NEET_Report from './jsx/ReusableComponent/NEET/Examination/NEET_Report';
import NeetHomePage from './jsx/ReusableComponent/NEET/NeetHomePage';
import DynamicNEETArticle from './jsx/ReusableComponent/NEET/DynamicNEETArticle';
import NeetPaymentSuccessPage from './jsx/ReusableComponent/NEET/NeetPaymentSuccess';
import NeetAllSubjectsHome from './jsx/ReusableComponent/NEET/NeetAllSubjects/NeetAllSubjectsHome';
import Testing from './jsx/ReusableComponent/NEET/Testing';
import Signup from './jsx/Signup/Signup';
import Terms from './jsx/TermsCondition/Terms';
import PrivacyPolicy from './jsx/PrivacyPolicy/PrivacyPolicy';
import TestStart from './jsx/TestStartComponent/TestStart';
import UGC_DynamicAPTITUDETestSeriesHome from './jsx/UGC_NET/GENERAL_APTITUDE/UGC_DynamicAPTITUDETestSeriesHome';
import UGC_NET_Home from './jsx/UGC_NET/UGC_NET_Home';
import UGC_Resources from './jsx/UGC_NET/UGC_Resourses';
import AttemptTestUGC from './jsx/UGC_NET/AttemptTestUGC';
import UGC_Report from './jsx/UGC_NET/UGC_Report';
import SubjectSpecificHome from './jsx/UGC_NET/SUBJECT_SPECIFIC/SubjectSpecificHome';
import UGC_TestSeries from './jsx/UGC_NET/UGC_TestSeries';
import UGC_CombinedHomePage from './jsx/UGC_NET/COMBINED/UGC_CombinedHomePage';
import LiveStreaming from './jsx/live_streaming/LiveStreaming';
import YoutubeCustomVP from './jsx/live_streaming/YoutubeCustomVP';
import ExamBodyInfo from './jsx/ExamBodyInfo/ExamBodyInfo';
import DynamicCUETArticle from './jsx/CUET/DynamicCUETArticle';
import VerifyEmail from './jsx/VerifyEmail/VerifyEmail';
import UGSyllabus from './jsx/UGNEETPage/UGHOME/UGSyllabus';
import DynamicUGCArticle from './jsx/UGC_NET/DynamicUGCArticle';



function App() {
  const [isTokenSetInHeader, setIsTokenSetInHeader] = useState(false);
  ReactGA.initialize('G-4FL6HLCW58');

  //USER TRACKING SYSTEM
  useEffect(() => {
    const uniqueUserId = localStorage.getItem('uniqueUserId');
    if (!uniqueUserId) {
      localStorage.setItem('uniqueUserId', getUniqueId());
    }

    // set unique deviceId in cookies
    const deviceId = getCookie('deviceId');
    if (!deviceId) {
      saveCookie('deviceId', getUniqueId());
    }
    // saveUserActivity("page_view", "home page", "/");
    // setIPAdderess();
    setIsTokenSetInHeader(setTokenInHeader());
    ;
  }, [])

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'PrintScreen') {
        navigator.clipboard.writeText(""); // Clear clipboard
        alert("Screenshots are disabled.");
      }
    };
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Blur the UI or stop the video
        document.body.style.filter = "blur(25px)";
        // Logic to stop the live stream playback
      } else {
        document.body.style.filter = "none";
      }
    }
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener('keyup', handleKeyDown);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener('keyup', handleKeyDown);
    };
  }, [])

  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const storedLoggedIn = localStorage.getItem('isLoggedIn');
    return storedLoggedIn ? JSON.parse(storedLoggedIn) : false;
  });
  const [authtoken, setAuthtoken] = useState(() => {
    const storedAuthToken = localStorage.getItem('authtoken');
    return storedAuthToken ? storedAuthToken : null;
  });
  const [prevPath, setPrevPath] = useState(() => {
    const storedAuthToken = localStorage.getItem('prevPath');
    return storedAuthToken ? storedAuthToken : null;
  });

  useEffect(() => {
    localStorage.setItem('isLoggedIn', JSON.stringify(isLoggedIn));
  }, [isLoggedIn]);


  const reloadComponent = () => {
    window.scrollTo(0, 0);
  }
  return (
    <HelmetProvider>
      {isTokenSetInHeader && <div className="App">
        <BrowserRouter>
          <AnalyticsTracker />
          <Header isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} setAuthtoken={setAuthtoken} reloadComponent={reloadComponent} />
          <Routes>
            {/* <Route path='*' element={!isLoggedIn && <Navigate to="/" />} /> */}
            <Route path='/' element={<Home setPrevPath={setPrevPath} />} />
            {/* <Route path='/live-streaming' element={<LiveStreaming />} /> */}
            <Route path='/live-streaming' element={<YoutubeCustomVP videoId="VvYR-KvLBxg" />} />
            <Route path='/home' element={<Home setPrevPath={setPrevPath} />} />
            <Route path='/historycourse/history-optional-courses' element={<HistoryOptionalCourses />} />
            <Route path='/civils' element={<CivilsCard />} />
            <Route path='/civilstestseries' element={<CivilsTest />} />
            <Route path='/about/:abouturl' element={<DynamicaboutPage />} />
            <Route path='/about-us' element={<Civilabout />} />
            <Route path="/course/history-optional" element={<CivilOpt />} />
            <Route path="/course/:coursename" element={<DynamicCourse />} />
            <Route path="/course-lesson/:lessonurl" element={<CourseDescription />} />
            <Route path='/testseries/:testseriesname' element={<DynamicTestseries />} />
            <Route path='/terms-and-conditions' element={<Terms pageName="Terms and Conditions" />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy pageName="Privacy Policy" />} />

            {/* books */}
            <Route path='/books' element={<Books />} />
            <Route path='/books/:bookTitleURL' element={<BookDetailsNew />} />
            <Route path='/books/practice-test/:titleURL' element={<BookTestSeries />} />
            <Route path='/books/practice-test/start-test/:courseId/:packageId' element={<StartBookTest />} />
            <Route path='/books/practice-test/attemt/:packageid' element={<AttemptTest />} />
            <Route path='/books/practice-test/report-dashboard' element={<ReportDashboard />} />
            <Route path='/books/practice-test/detailed-report' element={<BookPracticeTestReport />} />
            <Route path='/books/book-lesson/:lessonurl' element={<BookLessonPage />} />
            <Route path='/books/book-lesson-quiz-result' element={<LessonResult />} />

            <Route path="/daily-current-affairs/News" element={<Current />} />
            <Route path="/interview-guidance-program" element={<InterviewGuidance />} />
            <Route path="/readmore/News/:newsurl" element={<DynamicNews />} />
            <Route path='/login/'>
              <Route path='' element={isLoggedIn ? <Navigate to="/StudentDashboard" /> : <Login setIsLoggedIn={setIsLoggedIn} setAuthtoken={setAuthtoken} prevPath={prevPath} />} />
              <Route path='forgot' element={<Forgot />} />
            </Route>
            <Route path='/blogs' element={<BlogPage />} />

            <Route path='/upsc-quiz/:dynamicSubjectURL/:dynamicSectionURL/:dynamicQuestionID?' element={
              <QuizDetailsProvider >
                <Homequiz />
              </QuizDetailsProvider>
            }
            />

            {/* CUET ROUTES */}
            <Route path='/cuet' element={<Cuet />} />

            <Route path='/cuet/Language-Subjects' element={<LanguageSubjectsHome />} />
            <Route path='/cuet/Domain-Specific-Subjects' element={<DomainSpecificSubjectsHome />} />
            <Route path='/cuet/General-Aptitude-Test' element={<GeneralAptitudeTestHome />} />

            <Route path='/cuet/online-exam/instructions' element={<Instructions exam='cuet' />} />
            <Route path='/cuet/online-exam/live-test' element={<AttemptTestCUET />} />
            <Route path='/cuet/online-exam/report' element={<CUET_Report />} />
            <Route path="/cuet/paymentsuccess" element={<PaymentSuccessPage />} />
            <Route path="/cuet/resources" element={<CUET_Resources />} />
            <Route path="/cuet/article/:title" element={<DynamicCUETArticle />} />

            {/* ugc ROUTES */}
            <Route path='/ugc-net' element={<UGC_NET_Home />} />
            <Route path='/ugc-net/test-series' element={<UGC_TestSeries />} />
            <Route path='/ugc-net/dynamic-testseries/general-aptitude' element={<UGC_DynamicAPTITUDETestSeriesHome />} />
            <Route path='/ugc-net/dynamic-testseries/subject-specific' element={<SubjectSpecificHome />} />
            <Route path='/ugc-net/dynamic-testseries/combined' element={<UGC_CombinedHomePage />} />
            <Route path="/ugc-net/resources" element={<UGC_Resources />} />
            <Route path='/ugc-net/syllabus' element={<UGSyllabus />} />
            <Route path='/ugc-net/online-exam/instructions' element={<Instructions exam='ugc-net' />} />
            <Route path='/ugc-net/online-exam/live-test' element={<AttemptTestUGC />} />
            <Route path='/ugc-net/online-exam/report' element={<UGC_Report />} />
            <Route path="/ugc-net/article/:title" element={<DynamicUGCArticle />} />

            {/* <Route path='/cuet/section-IA' element={<SectioIA_Home />} />
            <Route path='/cuet/section-II' element={<SectioII_Home />} />
            <Route path='/cuet/section-III' element={<SectionIII_Home />} />
            <Route path='/cuet/online-exam/instructions' element={<Instructions exam='cuet' />} />
            <Route path='/cuet/online-exam/live-test' element={<AttemptTestCUET />} />
            <Route path='/cuet/online-exam/report' element={<CUET_Report />} />
            <Route path="/cuet/paymentsuccess" element={<PaymentSuccessPage />} />
            <Route path="/cuet/resources" element={<CUET_Resources />} /> */}

            {/* NEET ROUTES */}
            <Route path='/neet/about' element={<NeetHomePage />} />
            <Route path='/test' element={<Testing />} />
            <Route path='/neet/classes' element={<NeetHomePage />} />
            <Route path='/neet/testseries' element={<NeetHomePage />} />
            <Route path='/neet/dynamic-testseries/:subjectName' element={<DynamicTestSeriesHome />} />
            <Route path="/neet/paymentsuccess" element={<NeetPaymentSuccessPage />} />
            <Route path='/neet/study-material' element={<NeetHomePage />} />
            <Route path='/neet/testseries/:testseriesname' element={<DynamicTestseries />} />
            <Route path="/neet/course/:coursename" element={<DynamicCourse />} />
            <Route path='/neet/online-exam/instructions' element={<Instructions exam='neet' />} />
            <Route path='/neet/online-exam/live-test' element={<AttemptTestNEET />} />
            <Route path='/neet/online-exam/report' element={<NEET_Report />} />
            <Route path="/neet/article/:title" element={<DynamicNEETArticle />} />
            <Route path='/neet/All-Subjects' element={<NeetAllSubjectsHome />} />


            <Route path='/blog/:blogurl' element={<Dynamicblog />} />

            {/* TestResultDetailView?customName=J7TkmbUnIHSyPl4bdNUo */}
            <Route path='/TestResultDetailView' element={<Reportcard1 />} />
            <Route path='/course-lesson-result' element={<Reportcard />} />
            <Route path='/blogs-today-in-history/detail/:todayurl' element={<DynamicToday />} />
            <Route path='/Registration' element={<Signup setIsLoggedIn={setIsLoggedIn} setAuthtoken={setAuthtoken} prevPath={prevPath} />} />
            <Route path='/contact-us' element={<Contact authtoken={authtoken} />} />
            <Route path="/paymentsuccess" element={<PaymentSuccess />} />
            <Route path="/paymentsuccess-igp" element={<PaymentSuccessIGP />} />

            <Route path='/testseries/finalresult' element={<Finalresult />} />
            <Route path='/teststart/:courseId/:testSeriesSn/:packageId/:emailId?' element={<TestStart />} />
            <Route path='/testseriesstart/:packageid/' element={<QuestionLayoutTestseries />} />
            <Route path='/terms-and-conditions' element={<Terms pageName='Terms and Conditions' />} />
            <Route path='/privacy-policy' element={<Terms pageName='Privacy Policy' />} />
            <Route path='/exam-body-info' element={<ExamBodyInfo />} />
            <Route path='/verify-email' element={<VerifyEmail />} />
            <Route path='/StudentDashboard' element={isLoggedIn ? <Dashborad /> : <Navigate to="/login" />} />

          </Routes>

          <Footer />
        </BrowserRouter>
      </div>}
      {/* <div className='bg-dark'>
        
      </div> */}
    </HelmetProvider>
  );
}

export default App;